export const GeneratingTemplate = `
  <div>
    <div class="generating-info">
      <h3 class="font-manrope text-gray-800">Generating Prompt...</h3>
    </div>
    <div class="wait-message">
      <span style="font-size: 16px" class="message">Your discussion prompt is being crafted. Please be patient...</span>
    </div>
    <div class="skeleton skeleton-line skeleton-line-extra-small animate-pulse" ></div>
    <div class="skeleton skeleton-line skeleton-line-extra-large animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-medium animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-small animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-extra-large animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-small animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-medium animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-large animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-small animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-medium animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-medium animate-pulse"></div>
  </div>
`;

export const GeneratingTemplateVerbal = `
  <div>
    <div class="generating-info mb-3">
      <h3 class="font-manrope text-2xl text-gray-800">Generating Prompt...</h3>
    </div>
    <div class="wait-message">
      <span style="font-size: 16px" class="message">Your discussion prompt is being crafted. Please be patient...</span>
    </div>
    <div class="skeleton skeleton-line skeleton-line-extra-small animate-pulse" ></div>
    <div class="skeleton skeleton-line skeleton-line-extra-large animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-medium animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-small animate-pulse"></div>
    <div class="skeleton skeleton-line skeleton-line-extra-large animate-pulse"></div>
  </div>

`;


// WEBPACK FOOTER //
// ./src/app/features/dashboard/NewRoundTable/Templates/Generating.js